import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel'

const addTogglePrevNextBtnsActive = (
    emblaApi: EmblaCarouselType,
    prevBtn: HTMLElement,
    nextBtn: HTMLElement
  ): (() => void) => {
    const togglePrevNextBtnsState = (): void => {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
      else prevBtn.setAttribute('disabled', 'disabled')
  
      if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
      else nextBtn.setAttribute('disabled', 'disabled')
    }
  
    emblaApi
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  
    return (): void => {
      prevBtn.removeAttribute('disabled')
      nextBtn.removeAttribute('disabled')
    }
  }
  
export const addPrevNextBtnsClickHandlers = (
    emblaApi: EmblaCarouselType,
    prevBtn: HTMLElement,
    nextBtn: HTMLElement
): (() => void) => {
    const scrollPrev = (): void => {
      emblaApi.scrollPrev()
    }
    const scrollNext = (): void => {
      emblaApi.scrollNext()
    }
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)
  
    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
        emblaApi,
        prevBtn,
        nextBtn
    )
  
    return (): void => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
    }
} 

export const carousel = () => {
    const carousels = document.querySelectorAll<HTMLElement>('.carousel__viewport');
    
    
    if (!carousels)
        return
    
    carousels.forEach((carousel) => {
        const loop = carousel.classList.contains('carousel--loop')
        const options = { loop: loop }
        const emblaApi = EmblaCarousel(carousel, options)

        if (carousel.closest('[data-inert-hidden-slides]')) {
            const updateFocusableSlide = () => {
                emblaApi.slideNodes().forEach((slide, index) => {
                    slide.inert = index !== emblaApi.selectedScrollSnap()
                })
            }
            emblaApi.on('select', updateFocusableSlide).on('reInit', updateFocusableSlide)
            updateFocusableSlide()
        }

        const prevBtnNode = carousel.querySelector<HTMLButtonElement>('.carousel__button--prev')
        const nextBtnNode = carousel.querySelector<HTMLButtonElement>('.carousel__button--next')

        if (!prevBtnNode || !nextBtnNode)
          return

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            emblaApi,
            prevBtnNode,
            nextBtnNode
        )
        
        emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
    })
}